import React, { Component } from "react";

export class Services extends Component {
  render() {
    return (
      <div id="courses" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Our Courses</h2>
            <p>
            We are providing short courses on Industrial Automation and PLC including HMI designing and VFD's with certificates.
            </p>
           
          </div>
          <div className="row">

          <div className="col-md-4">
          <img src="img/courses/plc.jpg" alt="plc" />
          <div className="service-desc">
                      <h3>PLC</h3>
              </div>
          </div>

          <div className="col-md-4">
          <img src="img/courses/industrial-instrumentation.jpg" alt="industrial-instrumentation" />
          <div className="service-desc">
                      <h3>Industrial Instrmentation</h3>
              </div>
          </div>

          <div className="col-md-4">
          <img src="img/courses/vfd.jpg" alt="vfd" />
          <div className="service-desc">
                      <h3>VFD</h3>
              </div>
          </div>

          </div>
            <br/><br/>
          <div className="row">


<div className="col-md-4">
<img src="img/courses/hmi.jpg" alt="hmi" />
<div className="service-desc">
            <h3>HMI</h3>
    </div>
</div>

<div className="col-md-4">
<img src="img/courses/communication-protocols.png" alt="communication-protocols" />
<div className="service-desc">
            <h3>Communication Protocols</h3>
    </div>
</div>

<div className="col-md-4">
<img src="img/courses/hands-wiring.jpg" alt="hands on wiring" />
<div className="service-desc">
            <h3>Hands on Wiring</h3>
    </div>
</div>

</div>


          <div className="row">
          <div className="col-md-12">

            <a id="enrollBtn2"
           className="btn btn-custom btn-md page-scroll">
            Enrolll Now
          </a>
          </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Services;
